/**
 * Recursively converts keys in an object from camelCase to snake_case.
 * @param obj The object with keys to convert.
 * @returns The object with keys converted to snake_case.
 * @example
 * // Returns { hello_world: 'value', nested_object: { nested_key: 'nested_value' } }
 * convertKeysToSnakeCase({ helloWorld: 'value', nestedObject: { nestedKey: 'nestedValue' } });
 */

type GenericObject = {
  // Needed to allow for indexing with a string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
};

export function convertKeysToSnakeCase(obj: GenericObject): GenericObject {
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }

  const snakeCaseObj: GenericObject = Array.isArray(obj) ? [] : {};
  Object.keys(obj).forEach((key) => {
    const value = obj[key];
    const snakeCaseKey = key.replace(
      /[A-Z]/g,
      (match) => `_${match.toLowerCase()}`
    );
    snakeCaseObj[snakeCaseKey] = convertKeysToSnakeCase(value);
  });
  return snakeCaseObj;
}
